import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { CoreMediaService } from '../../../../../@core/services/media.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { BaseFilterContainerComponent } from 'app/core/filter-system';
import { FilterManagerService } from 'app/core/filter-system';

@Component({
  selector: 'app-cashback-shop-filter',
  templateUrl: './cashback-shop-filter.component.html',
  styleUrls: ['./cashback-shop-filter.component.scss'],
  providers: [TranslatePipe],
})
export class CashbackShopFilterComponent extends BaseFilterContainerComponent implements OnChanges {
  @Input() categories: any[] = [];
  @Input() applyFiltersBtnEnabled = false;

  constructor(
    mediaObserver: MediaObserver,
    coreMediaService: CoreMediaService,
    translateService: TranslateService,
    router: Router,
    filterManager: FilterManagerService
  ) {
    super(mediaObserver, coreMediaService, translateService, router, filterManager);
  }

  getQueryParamKeys(): string[] {
    return ['categories'];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.categories && changes.categories.previousValue !== changes.categories.currentValue) {
      this.categories = changes.categories.currentValue;
    }
  }
}
